"use strict";import{tag as r}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const Gauge4Icon=({width:a=24,height:e=24,hidden:t=!1,title:l="Gauge4"}={})=>r`<svg
    xmlns="http://www.w3.org/2000/svg"
    height=${e}
    viewBox="0 0 36 36"
    width=${a}
    aria-hidden=${t?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label=${l}
  >
    <path
      d="m29.3 13.613 1.537-3.326A15.912 15.912 0 0 1 34 19.813a13.828 13.828 0 0 1-1.394 5.867.5.5 0 0 1-.806.133l-1.375-1.376a.491.491 0 0 1-.116-.508 12.467 12.467 0 0 0 .313-7.12 13.137 13.137 0 0 0-1.322-3.196ZM2.035 18.754a16.133 16.133 0 0 1 15.4-14.932 15.939 15.939 0 0 1 7.222 1.459l-1.986 2.49a12.562 12.562 0 0 0-5.22-.947A13.016 13.016 0 0 0 5 19.813a12.878 12.878 0 0 0 .691 4.117.492.492 0 0 1-.116.506L4.013 26a.5.5 0 0 1-.818-.154 15.842 15.842 0 0 1-1.16-7.092ZM26.99 7.089a.867.867 0 0 1 1.483.874l-7.71 17.643a3.219 3.219 0 0 1-4.646 1.639 3.219 3.219 0 0 1-.819-4.858Z"
    />
  </svg>`;
//# sourceMappingURL=Gauge4.js.map
